import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { PaidPlanContractView } from "~/backendApis/viewModel"
import ApplicationApiError from "~/backendApis/foundation/ApplicationApiError"

interface Params {
  universalCorporationId: string
}

export class GetCurrentPaidPlanContractReadRequest extends ReadRequest<PaidPlanContractView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<PaidPlanContractView | null> {
    return this.apiClient
      .get(this.makeEndpoint())
      .catch((e: ApplicationApiError) => {
        if (e.isNotFoundError()) {
          return null
        }
        throw e
      })
  }

  private makeEndpoint(): string {
    return `/corporation_contract/corporation_member/${this.params.universalCorporationId}/paid_plan_contract/current_contract`
  }
}
